import { MutationTree } from "vuex";
import { getDefaultPCState, IProgramContentState } from ".";
import { IProgramContent } from "@/models/programcontent";

export const mutations: MutationTree<IProgramContentState> = {
    setProgramContentsList(state, payload: IProgramContent[]) {
        state.error = null;
        state.programContentsList = [...payload];
    },
    setSelectedProgramContent(state, payload: IProgramContent) {
        state.selectedProgramContent = payload;
    },
    setProgramContentsError(state, payload: any) {
        state.error = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultPCState());
    },
};
